import React, { useContext, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { useFlag } from '@wix/da-shared-react/pkg/redux/flags/hooks';
import VisuallyHidden from '@wix/da-shared-react/pkg/a11y/VisuallyHidden';
import { MobileContext } from '@wix/da-shared-react/pkg/Context';
import { ScreenSizeContext } from '@wix/da-shared-react/pkg/Measured';
import TopicGrid from '@wix/da-shared-react/pkg/TopicGrid';
import {
  TopTopics as TopTopicsType,
  AllTopics,
} from '@wix/da-shared-react/pkg/types/topics';
import PageContainer from '../PageContainer';
import ContentLoader from '../ContentLoader';
import TopTopics from '../TopTopics';

import s from './TopicListPage.scss';

const LARGE_GUTTER_PX = 60;
const SMALL_GUTTER_PX = 40;
const MOBILE_GUTTER_PX = parseInt(s['mobile-gutter'], 10) || 16;
const GUTTER_BREAKPOINT = 1330;

export interface Props {
  /* an array of topics considered most popular */
  topTopics: TopTopicsType;
  /* array of all topics */
  allTopics: AllTopics;
}

const TopicListPage: React.FC<Props> = props => {
  const { t } = useTranslation();
  const isMobile = useContext(MobileContext);
  const shouldRenderH1 = useFlag('proposed_h1s');
  const { topTopics = [], allTopics = [] } = props;

  const containerRef = useRef(null);
  const { width: screenWidth } = useContext(ScreenSizeContext);
  let gutterSize = MOBILE_GUTTER_PX;
  if (!isMobile) {
    gutterSize =
      screenWidth > GUTTER_BREAKPOINT ? LARGE_GUTTER_PX : SMALL_GUTTER_PX;
  }
  const availableWidth = screenWidth - gutterSize * 2;

  return (
    <>
      {shouldRenderH1 && (
        <VisuallyHidden>
          <h1>{t('topicListPage.heading')}</h1>
        </VisuallyHidden>
      )}
      <PageContainer
        title={t('browseHeader.page.topics')}
        className={s['page-container']}
        withFooter
        withTabHeader
      >
        <ContentLoader>
          <div ref={containerRef} className={s['root']}>
            {!isMobile && (
              <TopTopics
                title={t('topicListPage.topTopics')}
                availableWidth={availableWidth}
                topTopics={topTopics}
                allTopics={allTopics}
              />
            )}
            <TopicGrid
              className={s['topic-grid']}
              screenWidth={screenWidth}
              allTopics={allTopics}
            />
          </div>
        </ContentLoader>
      </PageContainer>
    </>
  );
};
TopicListPage.displayName = 'TopicListPage';
export default TopicListPage;
